export enum ProductStatus {
  Active,
  Staged,
  Incomplete,
  Expired
}
